import { useCallback, useContext } from 'react';
import * as api from '@/api';
import { SearchLoadingDispatchContext, SearchResultsDispatchContext } from '@/containers/WorkspaceGlobalSearch/Context';
import type { WorkspaceSearchFull } from '@/types';

export default function useSearchFetchFiles() {
  const setResults = useContext(SearchResultsDispatchContext);
  const setLoading = useContext(SearchLoadingDispatchContext);

  const files = useCallback(async ({ filters, size }: FetchData) => {
    const result = await api.workspaces.globalSearch.files({
      filters,
      size,
    });

    if (result) {
      setResults(prev => ({
        ...prev,
        files: result,
      }));
    }
  }, [setResults]);

  const fetch = useCallback(({ filters, size }: FetchData) => {
    setLoading(prev => ({ ...prev, files: { ...prev.files, loading: true } }));
    Promise.all([
      new Promise<void>(resolve => setTimeout(() => resolve(), 250)),
      files({ filters, size }),
    ])
      .then(() => {
        setLoading(prev => ({ ...prev, files: { loading: false } }));
      });
  }, [files, setLoading]);

  return fetch;
}

export { useSearchFetchFiles };

type FetchData = {
  filters: WorkspaceSearchFull.File.Filters;
  size: number;
};